export default defineNuxtRouteMiddleware((to, from) => {
  // skip middleware on server
  if (import.meta.server) return

  const { event } = window

  // the navigate event does not work
  if (!event || event?.type === 'popstate') return

  const transition = event.currentTarget?.getAttribute?.('data-pageTransition')

  // skip middleware on initial load
  if (!transition) return

  // same page update will cause "setup" to be called twice
  // this is a workaround to prevent that
  if (from.meta.name !== to.meta.name) {
    // is there a better way to do this?
    to.meta.pageTransition = {
      name: transition ?? 'default-page',
      mode: 'out-in',
    }
    from.meta.pageTransition = {
      name: transition ?? 'default-page',
      mode: 'out-in',
    }
  }
})
